import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';

const FilterTags = () => {
    const dispatch = useDispatch();

    const { facetFilters = [], navigationTheme = '' } = useSelector(
        (state) => state.facetedSearch || {}
    );

    const selectedFacetGroup = facetFilters.filter(
        (filter) => filter.selectedOptions.length > 0
    );
    const selectedFacetOption = selectedFacetGroup.reduce(
        (accumulator, group) => {
            if (!group) {
                return accumulator;
            }
            const { options, selectedOptions } = group;
            const groupOptions = options
                .filter((option) => selectedOptions.includes(option.id))
                .map((option) => ({ ...option, group }));
            return [...accumulator, ...groupOptions];
        },
        []
    );
    return selectedFacetGroup.length === 0 ? null : (
        <div className="selected-filter">
            {navigationTheme === 'category' && (
                <>
                    {selectedFacetOption &&
                        selectedFacetOption.map((option, index) => (
                            <span
                                className="selected-filter__tag"
                                onClick={(event) =>
                                    dispatch(
                                        searchFacetChange(option.group, option)
                                    )
                                }
                                key={`option-${index}`}
                            >
                                {' '}
                                {option.label}{' '}
                            </span>
                        ))}
                </>
            )}
        </div>
    );
};

export default FilterTags;
